import get from "lodash/get";
import normalize from "json-api-normalizer";

import NotificationService from "../services/notification.service";
import { FETCH_VATS_OPTIONS_START, FETCH_VATS_OPTIONS_SUCCESS, FETCH_VATS_OPTIONS_FAILED } from "./types";
import VatsService from "../services/vats.service";

export const fetchVats = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_VATS_OPTIONS_START });
  try {
    const result = await VatsService.getVats();
    const normalizedVatsData = normalize(result.data);
    dispatch({
      type: FETCH_VATS_OPTIONS_SUCCESS,
      payload: normalizedVatsData
    });
  } catch (e) {
    dispatch({ type: FETCH_VATS_OPTIONS_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch vats data. ${NotificationService.handleMessage(e)}`);
  }
};
